var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',_vm._g(_vm._b({class:[_vm.$style.dialog, ( _obj = {}, _obj[_vm.$style.fullBody] = _vm.fullBody, _obj )],attrs:{"title":_vm.title}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.$slots.footer)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._t("footer")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }